import { useRef } from "react";
import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";

type Props = {
  uploading: boolean;
  disabled: boolean;
  hasSupplierAttachment: boolean;
  onUpload: (file: File) => void;
};

/** MSDS-5 — supplier PDF file picker + upload. */
export function ManufacturingMaterialSdsSupplierUpload({
  uploading,
  disabled,
  hasSupplierAttachment,
  onUpload,
}: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="rounded-md border border-dashed border-violet-300 bg-violet-50/50 px-3 py-3 dark:border-violet-800 dark:bg-violet-950/20">
      <p className="mb-1 text-xs font-semibold text-violet-950 dark:text-violet-100">
        Supplier SDS PDF
      </p>
      <p className="mb-2 text-[11px] text-violet-900/80 dark:text-violet-200/80">
        Prefer the manufacturer/distributor sheet when available. PDF only · max 25 MB.
        {hasSupplierAttachment ? " · file attached on this draft" : ""}
      </p>
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf,.pdf"
        className="hidden"
        onChange={(e) => {
          const f = e.target.files?.[0];
          e.target.value = "";
          if (f) onUpload(f);
        }}
      />
      <button
        type="button"
        className={ghostBtnClass}
        disabled={disabled || uploading}
        onClick={() => inputRef.current?.click()}
      >
        {uploading ? "Uploading…" : hasSupplierAttachment ? "Replace supplier PDF" : "Upload supplier PDF"}
      </button>
    </div>
  );
}
